import { useState, useEffect } from 'react';
import { RadioGroup } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import uploadBtnBgImg from '../../../../../static/images/upload-button-background-image.png';
import { i18n } from '../../../../../language';
import { dutyAssignAPI } from '../../../../../apis';
import CustomRadio from '../../../../../components/Radio';
import CustomButton from '../../../../../components/Button';
import { Dialog } from '../../../../../components';
import './style.css';

export const FileType = {
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  xls: 'application/vnd.ms-excel',
};

const FILETYPELIST = [
  // xlsx, xls
  FileType['xlsx'],
  FileType['xls'],
];
const FILESIZE = 30 * 1024 * 1024;

export const base64ToBlobDownload = (base64, fileName) => {
  const type = FileType.xls;
  const a = window.atob(base64);
  const len = a.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = a.charCodeAt(i);
  }
  const blob = new Blob([bytes], { type });
  const downLink = document.createElement('a');
  downLink.href = URL.createObjectURL(blob);
  downLink.download = fileName;
  downLink.target = '_blank';
  downLink.click();
};

const Upload = (props) => {
  const { classes, uploads, handleUploads } = props;
  const inputFileId = 'upload-file-button-input';

  const uploadFileOuterCls = 'upload-file-outer-container';
  let dom = null;

  const [dialogAlert, setDialogAlert] = useState({ open: false, title: '', text: '' });
  const handleDialogAlertOpen = (title, text) => setDialogAlert({ open: true, title, text });
  const handleDialogAlertClose = () => setDialogAlert({ open: false, title: '', text: '' });

  /**
   * ------------------------------------
   * After onChange or file is incorrect
   * need clear Input's value
   * ------------------------------------
   */
  const clearInputValue = () => {
    const input = document.getElementById(inputFileId);
    if (input) input.value = '';
  };

  const validateFile = (file) => {
    /**
     * ----------------------------------------
     * validate the file type is right or not,
     * if incorrect, pop error-msg and return
     * ----------------------------------------
     */
    let typeCorrect = false;
    FILETYPELIST.forEach((type) => {
      if (type === file.type) typeCorrect = true;
    });
    if (!typeCorrect) {
      handleDialogAlertOpen('Error', 'Please convert the uploaded file in XLSX format.');
      clearInputValue();
      return false;
    }
    /**
     * ----------------------------------------
     * Validate the file-size is over 30MB or not
     * if over, show alert and return
     * ----------------------------------------
     */
    const sizeCorrect = file.size <= FILESIZE;
    if (!sizeCorrect) {
      handleDialogAlertOpen('Error', 'The file size is over Maximum 30MB !');
      clearInputValue();
      return false;
    }
    return true;
  };

  const handleFileToBase64 = (file) => {
    const fileName = file.name;
    const reader = new FileReader();
    reader.onload = (event) => {
      const result = event.target.result;
      const fileBase64 = result.split(',')[1];
      if (typeof handleUploads === 'function') handleUploads({ ...uploads, file: { fileName, fileBase64 } });
    };
    reader.readAsDataURL(file);
  };

  const handleInputFileChange = (e) => {
    const { files = [] } = e.target;
    const file = files.length ? files[0] : null;
    if (!validateFile(file)) return;
    handleFileToBase64(file);
    clearInputValue();
  };

  const handleDragover = (e) => {
    e.preventDefault();
    dom.classList.add('dragover');
  };
  const handleDragleave = (e) => {
    e.preventDefault();
    dom.classList.remove('dragover');
  };
  const handleDrop = (e) => {
    e.preventDefault();
    dom.classList.remove('dragover');
    const files = e.dataTransfer.files;
    const file = files[0];
    if (!validateFile(file)) return;
    handleFileToBase64(file);
    clearInputValue();
  };
  useEffect(() => {
    dom = document.querySelector(`.${uploadFileOuterCls}`);
    dom.addEventListener('dragover', handleDragover);
    dom.addEventListener('dragleave', handleDragleave);
    dom.addEventListener('drop', handleDrop);
    return () => {
      dom.removeEventListener('dragover', handleDragover);
      dom.removeEventListener('dragleave', handleDragleave);
      dom.removeEventListener('drop', handleDrop);
    };
    // eslint-disable-next-line
  }, [uploads]);

  const handleRadioChange = (e) => {
    const { name, value } = e.target;
    const changes = { [name]: Number(value) };
    if (name === 'mode' && Number(value) === 0) changes['option'] = null;
    if (typeof handleUploads === 'function') handleUploads({ ...uploads, ...changes });
  };

  const handleDeleteButtonClick = () => {
    if (typeof handleUploads === 'function') handleUploads({ ...uploads, file: null });
  };

  const handleDownloadButtonClick = async () => {
    try {
      const { result } = await dutyAssignAPI.getTemplateStaff();
      const { content, fileName } = result;
      base64ToBlobDownload(content, fileName);
    } catch (error) {
      console.log('-----handleDownloadButtonClick error----->', error);
    }
  };

  return (
    <div className="upload-container">
      <div className={`upload-excel-container ${uploadFileOuterCls}`}>
        <div className="upload-content" id="upload-excel-content">
          <label className="upload-label" id="upload-file-label" htmlFor={inputFileId} />
          <input
            id={inputFileId}
            className="upload-input"
            type="file"
            accept={FILETYPELIST.toString()}
            onChange={handleInputFileChange}
          />
          <div className="upload-button-bg-img align-center">
            <img src={uploadBtnBgImg} alt="" />
          </div>
          <div className="upload-text align-center">
            <div>
              <b>{i18n.t('DUTY_ASSIGN_UPLOAD_DIALOG_INPUT_LABEL')}</b>
            </div>
            <div>
              <span style={{ fontSize: '1.5rem' }}>
                {i18n.t('DUTY_ASSIGN_UPLOAD_DIALOG_INPUT_TEXT1')}
                <u style={{ fontSize: '1.6rem' }}>{i18n.t('DUTY_ASSIGN_UPLOAD_DIALOG_INPUT_TEXT2')}</u>
              </span>
            </div>
          </div>
        </div>
        {uploads.file ? (
          <div className="selected-file">
            <div className="delete-button">
              <IconButton id="excel-delete-button" size="small" onClick={handleDeleteButtonClick}>
                <CloseIcon fontSize="inherit" />
              </IconButton>
            </div>
            <div className="file-name">
              <span id="added-upload-file-name">{uploads.file?.fileName}</span>
            </div>
          </div>
        ) : null}

        <Dialog
          readOnly
          open={dialogAlert.open}
          title={dialogAlert.title}
          handleClose={handleDialogAlertClose}
          cancel="OK"
          handleCancel={handleDialogAlertClose}
        >
          {dialogAlert.text}
        </Dialog>
      </div>
      <div className="upload-radio-container" style={{ paddingTop: '.7rem' }}>
        <div className={`${classes.dialogTitle} upload-title`} id="upload-from-excel-upload-mode">
          {i18n.t('DUTY_ASSIGN_UPLOAD_DIALOG_MODE_TITLE')}
        </div>
        <div>
          <RadioGroup row>
            <CustomRadio
              id="upload-excel-mode-staff-duty-radio"
              name="mode"
              label={
                <span id="upload-excel-mode-staff-duty-label">
                  {i18n.t('DUTY_ASSIGN_UPLOAD_DIALOG_MODE_RADIO_STAFF_DUTY_LABEL')}
                </span>
              }
              value={0}
              checked={uploads.mode === 0}
              onChange={handleRadioChange}
            />
            <CustomRadio
              id="upload-excel-mode-staff-only-radio"
              name="mode"
              label={
                <span id="upload-excel-mode-staff-only-label">
                  {i18n.t('DUTY_ASSIGN_UPLOAD_DIALOG_MODE_RADIO_STAFF_ONLY_LABEL')}
                </span>
              }
              value={1}
              checked={uploads.mode === 1}
              onChange={handleRadioChange}
            />
          </RadioGroup>
        </div>
      </div>
      <div className="upload-radio-container" style={{ paddingTop: '.7rem' }}>
        <div className={`${classes.dialogTitle} upload-title`} id="upload-from-excel-upload-staff-list-only-options">
          {i18n.t('DUTY_ASSIGN_UPLOAD_DIALOG_STAFF_ONLY_TITLE')}
        </div>
        <div>
          <RadioGroup row>
            <CustomRadio
              id="upload-excel-staff-only-options-overwrite-radio"
              name="option"
              label={
                <span id="upload-excel-staff-only-options-overwrite-label">
                  {i18n.t('DUTY_ASSIGN_UPLOAD_DIALOG_STAFF_ONLY_RADIO_OVERWRITE_LABEL')}
                </span>
              }
              value={0}
              checked={uploads.option === 0}
              disabled={uploads.mode === 0}
              onChange={handleRadioChange}
            />
            <CustomRadio
              id="upload-excel-staff-only-options-append-radio"
              name="option"
              label={
                <span id="upload-excel-staff-only-options-append-label">
                  {i18n.t('DUTY_ASSIGN_UPLOAD_DIALOG_STAFF_ONLY_RADIO_APPEND_LABEL')}
                </span>
              }
              value={1}
              checked={uploads.option === 1}
              disabled={uploads.mode === 0}
              onChange={handleRadioChange}
            />
          </RadioGroup>
        </div>
      </div>
      <div className="download-button-container" style={{ paddingTop: '.7rem' }}>
        <CustomButton
          id="download-blank-excel-button"
          fullWidth
          buttonColor="green"
          onClick={handleDownloadButtonClick}
        >
          {i18n.t('DUTY_ASSIGN_UPLOAD_DIALOG_DOWNLOAD_BUTTON_TEXT')}
        </CustomButton>
      </div>
    </div>
  );
};

export default Upload;
